<template>
  <div class="bg-white rounded-lg m-3">
    <div class="border-b-0.5 flex justify-between items-center">
      <p class="text-sm font-semibold">{{ title }}</p>
    </div>

    <transition name="fade">
      <div
        v-if="get_error"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ get_error }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="edit_error"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ edit_error }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="delete_error"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ delete_error }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="create_error"
        class="p-1 text-center text-sm w-full bg-green-200"
      >
        {{ create_error }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="create_success"
        class="p-1 text-center text-sm w-full bg-green-200"
      >
        {{ create_success }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="edit_success"
        class="p-1 text-center text-sm w-full bg-green-200"
      >
        {{ edit_success }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="delete_success"
        class="p-1 text-center text-sm w-full bg-green-200"
      >
        {{ delete_success }}
      </div>
    </transition>

    <div class="py-5">
      <div class="text-sm mb-3">
        <label class="block pb-1">Assign Leave Workflow</label>
        <el-select
          v-model="selectedLeaveWorkflow"
          @change="assignEmployeeLeaveWorkflow()"
          filterable
          placeholder="Select"
          class="w-full"
        >
          <el-option
            v-for="workflow in leaveWorkflows"
            :key="workflow.Id"
            :label="workflow.Name"
            :value="workflow.Id"
          >
          </el-option>
        </el-select>
      </div>

      <label class="block pb-1">Assign Leaves</label>
      <div
        v-if="organizationLeaveTypes.length > 0"
        class="grid lg:grid-cols-4 justify-start gap-y-4 w-3/4 text-sm"
      >
        <div v-for="leaveType in organizationLeaveTypes" :key="leaveType.Id">
          <input
            type="checkbox"
            :id="leaveType.Id"
            @change="
              (isChecked) => assignEmployeeLeaveTypes(isChecked, leaveType)
            "
            :checked="isAssigned(leaveType.Id)"
          />
          <label :for="leaveType.Id" class="font-bold mb-2 cursor-pointer">
            {{ leaveType.Name }}
          </label>
        </div>
      </div>
      <p class="text-center p-2" v-else>No Leave Types</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "leavessInfoCard",
  props: ["title", "data"],
  data() {
    return {
      edit_error: null,
      create_success: null,
      create_error: null,
      get_error: null,
      delete_error: null,
      delete_success: null,
      edit_success: null,
      organizationLeaveTypes: [],
      myLeaveTypes: [],
      leaveWorkflows: [],
      selectedLeaveWorkflow: null,
    };
  },

  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getTabTitle",
      "getCurrentEmployeeId",
    ]),
  },

  methods: {
    isAssigned(leaveTypeId) {
      return this.myLeaveTypes.some(
        (leave) => leave.LeaveType && leave.LeaveTypeId === leaveTypeId
      );
    },

    getLeaveWorkflows() {
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/leave/workflow/group/v1/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode === 200) {
              this.leaveWorkflows = response.data.Data;
              //console.log(this.leaveWorkflows);
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
            setTimeout(() => {
              this.get_error = null;
            }, 2500);
          }
        );
    },

    getLeaveTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/leavetype/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode === 200) {
              this.get_success = response.data.StatusMessage;
              this.organizationLeaveTypes = response.data.Data;
              //console.log(this.organizationLeaveTypes);
              this.loading = false;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
            setTimeout(() => {
              this.showEditError = false;
            }, 2000);
          }
        );
    },

    assignEmployeeLeaveTypes(isChecked, leave) {
      if (!isChecked.target.checked) {
        this.deleteLeaveTypesAssignedToEmployee(leave.Id);
        return;
      }
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      const data = {
        EmployeeId: this.getCurrentEmployeeId,
        LeaveTypeId: leave.Id,
      };
      axios
        .post(
          `${this.getOrganization}/employee/leave/type/${this.$ApiVersion}/assign`,
          data,
          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode === 200) {
              this.loading = false;
              this.create_success = response.data.StatusMessage;
              this.getEmployeeLeaveInfo(this.getCurrentEmployeeId);
              setTimeout(() => {
                this.create_success = null;
              }, 2500);
            } else {
              this.create_error = response.data.StatusMessage;
              this.getEmployeeLeaveInfo(this.getCurrentEmployeeId);
              this.loading = false;
              setTimeout(() => {
                this.create_error = null;
              }, 2500);
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
            setTimeout(() => {
              this.create_error = null;
            }, 2500);
          }
        );
    },

    deleteLeaveTypesAssignedToEmployee(leaveTypeId) {
      const data = {
        EmployeeId: this.getCurrentEmployeeId,
        EmployeeLeaveTypeId: leaveTypeId,
      };
      this.loading = true;
      axios
        .delete(
          `${this.getOrganization}/employee/leave/type/${this.$ApiVersion}/delete`,
          {
            headers: {
              Authorization: `Bearer ${this.getToken}`,
              "Content-Type": "application/json",
            },
            data,
          }
        )
        .then(
          (response) => {
            if (response.data.StatusCode === 200) {
              this.loading = false;
              this.getEmployeeLeaveInfo(this.getCurrentEmployeeId);
              this.delete_success = response.data.StatusMessage;
              setTimeout(() => {
                this.delete_success = null;
              }, 2500);
            } else {
              this.loading = false;
              this.delete_error = response.data.StatusMessage;
              this.getEmployeeLeaveInfo(this.getCurrentEmployeeId);
            }
          },
          (error) => {
            this.loading = false;
            this.delete_error = error.message;
            setTimeout(() => {
              this.delete_error = null;
              this.getEmployeeLeaveInfo(this.getCurrentEmployeeId);
            }, 2500);
          }
        );
    },

    getEmployeeLeaveInfo() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/${this.getCurrentEmployeeId}/leave/${this.$ApiVersion}/info`,
          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode === 200) {
              this.get_success = response.data.StatusMessage;
              this.myLeaveTypes = response.data.Data.AssignedLeaveTypes;
              this.selectedLeaveWorkflow =
                response.data.Data.LeaveWorkflowGroup;
              this.loading = false;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
            setTimeout(() => {
              this.showEditError = false;
            }, 2000);
          }
        );
    },

    assignEmployeeLeaveWorkflow() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      const workflow = {
        EmployeeId: this.getCurrentEmployeeId,
        LeaveWorkflowGroupId: this.selectedLeaveWorkflow,
      };
      axios
        .put(
          `${this.getOrganization}/employee/leave/workflow/v1/assign`,
          workflow,
          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode === 200) {
              this.loading = false;
              this.edit_success = response.data.StatusMessage;
              setTimeout(() => {
                this.edit_success = false;
              }, 2000);
            } else {
              this.edit_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.edit_error = error.message;
            setTimeout(() => {
              this.showEditError = false;
            }, 2000);
          }
        );
    },
  },

  created() {
    this.getLeaveTypes();
    this.getEmployeeLeaveInfo();
    this.getLeaveWorkflows();
  },
};
</script>
